module.exports = {
    "breadcrumbs": `Atpaka\u{13C}ce\u{13C}i`
};


//# sourceMappingURL=lv-LV.main.js.map
